// Окрестность навыка: на чём он стоит и что открывает, один прыжок в каждую
// сторону. Стоит на карточке «Новый навык на сегодня».
//
// Это не карта и не прогресс. Полного вида карты у ученика в фазе 1 нет —
// схема на 226 узлов отвечает долей серого, а не числом, и возвращает ту самую
// развилку из четырёх чисел, которую 11 сентября свели к одному. Обход карты
// по одному узлу за нажатие был бы тем же самым, выданным порциями, поэтому
// имена здесь не нажимаются. Разбор — `docs/02-decisions.md`, «Карта ученику».

import type { SkillNeighbours } from "../contract";

/**
 * Сколько «откроет» показать. Вниз резать нечего — предпосылок не больше
 * четырёх на всю карту, — а вверх есть: «Линейное уравнение» открывает 11.
 * Три имени и остаток числом: список длиннее читается как перечень, а карточка
 * отвечает на «куда это ведёт», а не «перечисли всё».
 */
const SHOW = 3;

// Имя навыка — не слово, а фраза с двоеточием и придаточным: «Квадратное
// уравнение с параметром: число корней через дискриминант». Имена, слитые в
// строку через разделитель, на ширине карточки переносятся и склеиваются —
// граница между соседями теряется ровно там, где она и нужна. Поэтому имя в
// строке одно. Проверено в браузере 14 сентября 2026: первая версия была
// через « · », и прочитать её было нельзя.

export function Neighbours({ skill }: { skill: SkillNeighbours }) {
  const opens = skill.opens.slice(0, SHOW);
  const more = skill.opens.length - opens.length;
  // У 69 навыков из 226 не открывается ничего, и у корня карты не на чем
  // стоять. Пустой ряд с подписью был бы враньём формы: подпись обещает
  // содержание, которого в карте нет.
  if (skill.standsOn.length === 0 && opens.length === 0) return null;
  return (
    <div className="nbhd">
      {skill.standsOn.length > 0 ? (
        <>
          <div className="nbhd__label">стоит на</div>
          <div className="nbhd__names">
            {skill.standsOn.map((s) => (
              <div key={s.skillId}>{s.name}</div>
            ))}
          </div>
        </>
      ) : null}
      {opens.length > 0 ? (
        <>
          <div className="nbhd__label">откроет</div>
          <div className="nbhd__names">
            {opens.map((s) => (
              <div key={s.skillId}>{s.name}</div>
            ))}
            {more > 0 ? (
              <div className="nbhd__more">
                и ещё <span className="num">{more}</span>
              </div>
            ) : null}
          </div>
        </>
      ) : null}
    </div>
  );
}
